export const renderSprite = () => {
  const ajax = new XMLHttpRequest()
  ajax.open('GET', '/sprite.svg', true)
  ajax.send()
  ajax.onload = () => {
    const div = document.createElement('div')
    div.classList.add('hidden')
    div.innerHTML = ajax.responseText
    document.body.insertBefore(div, document.body.childNodes[0])
  }
}
